import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

// Column
import { ProToOrgListColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, ProToOrgStatusOptions } from '../../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails } from '../../../service/ProductService';

import { PROTOORG_LIST, PRO_TO_ORG_REJECT } from '../../../config/ApiConstant';
import moment from 'moment';
import { ApplicationTab } from '../applicationTab';
import { OtherApplicationTab } from './OtherApplicationTab';
import { createdAtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Tooltip } from 'primereact/tooltip';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const ProToOrg = () => {
    document.title = 'Provisional to Original Application | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const [searchVal, setSearchVal] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('proorg_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [rejectProToOrgModal, setRejectProToOrgModal] = useState<boolean>(false);
    const [rejectProToOrgLoader, setRejectProToOrgLoader] = useState<boolean>(false);
    const [rejectId, setRejectId] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getAllProToOrgList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get all provisional to original list
    const getAllProToOrgList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(PROTOORG_LIST + '?start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getAllProToOrgList()} />
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'proorg_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };
    //remove serach
    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getAllProToOrgList();
    };
    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={ProToOrgStatusOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        return (
            <>
                <Badge
                    severity={rowData.generate_status === 'No' ? 'warning' : rowData.generate_status === 'Rejected' ? 'danger' : 'success'}
                    value={rowData.generate_status === 'No' ? 'Pending' : rowData.generate_status === 'Rejected' ? 'Rejected' : 'Approved'}
                ></Badge>
            </>
        );
    };

    // Template for address
    const addressTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.PAddress} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.PAddress) ? rowData.PAddress : ''}</div>
                </Button>
            </>
        );
    };

    // Template for pro to original
    const proToOriginalTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    {window.cn(rowData.pro_to_original_url) ? (
                        <>
                            <Tooltip target=".pro-to-original-url" position="top" />
                            <span className="pro-to-original-url" data-pr-tooltip="Old Reg No. Visit Council">
                                <Button icon="pi pi-eye" disabled={true} />
                            </span>
                        </>
                    ) : (
                        <Button
                            tooltip={window.cn(rowData.pro_to_original_url) ? 'Old Reg No. Visit Council' : 'Provisional Certificate'}
                            icon="pi pi-eye"
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => window.open(rowData.pro_to_original_url, '_blank')}
                        />
                    )}
                </div>
            </>
        );
    };

    // Template for degree certificate
    const degCertTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Degree Certificate" icon="pi pi-eye" tooltipOptions={{ position: 'top' }} onClick={() => window.open(rowData.degree_certi_url, '_blank')} />
                </div>
            </>
        );
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button label="Reject" className="p-button-danger" onClick={() => openProToOrgModal(rowData.id)} disabled={rowData.generate_status === 'No' ? false : true} />
                </div>
            </>
        );
    };

    // Open reject pro to org modal
    const openProToOrgModal = (id: any) => {
        setRejectId(id);
        setRejectProToOrgModal(true);
    };

    // Close reject pro to org modal
    const closeProToOrgModal = () => {
        setRejectId(null);
        setRejectProToOrgLoader(false);
        setRejectProToOrgModal(false);
    };

    // Reject pro to org
    const rejectProToOrg = async () => {
        try {
            setRejectProToOrgLoader(true);
            // Delete api call
            const response = await deleteDataWithMultipleParameters(PRO_TO_ORG_REJECT + '?id=' + rejectId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setRejectProToOrgLoader(false);
                setRejectProToOrgModal(false);
                setRejectId(null);
                getAllProToOrgList();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setRejectProToOrgLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setRejectProToOrgLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
             <ApplicationTab mainTabLabel="Other Application" />
            <OtherApplicationTab initialTabLabel="Pro To Org" />
            <Toast ref={toast} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {ProToOrgListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'generate_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'PAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={addressTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={createdAtTemplate} sortable style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'pro_to_original_url') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={proToOriginalTemplate} />;
                                        } else if (col.field === 'degree_certi_url') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={degCertTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '9rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ProToOrgListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Reject Dialog */}
            <Dialog
                visible={rejectProToOrgModal}
                style={{ width: '450px' }}
                header="Reject Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeProToOrgModal} />
                        <Button label="Reject" icon="pi pi-trash" className="p-button-danger" onClick={rejectProToOrg} loading={rejectProToOrgLoader} />
                    </>
                }
                onHide={closeProToOrgModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Are you sure you want to Reject this Application?</span>
                </div>
            </Dialog>
        </>
    );
};
